import { Component, type ErrorInfo, type ReactNode } from "react";
import { Logo } from "../brand/Logo";
import { Button } from "./Button";

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Unhandled UI error", error, info.componentStack);
  }

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flex: 1, gap: 24, padding: 32, textAlign: "center" }}>
        <Logo size={56} />
        <h1 style={{ fontSize: 22 }}>Что-то пошло не так</h1>
        <p style={{ color: "var(--color-ink-subtle)", maxWidth: 320 }}>
          Произошла непредвиденная ошибка. Попробуйте перезапустить приложение.
        </p>
        <Button onClick={() => window.location.reload()} style={{ maxWidth: 240 }}>
          Обновить
        </Button>
      </div>
    );
  }
}
